import { routerReducer as routing } from 'react-router-redux';
import { combineReducers } from '@reduxjs/toolkit';
import changesets from '../ducks/changesets';
import project from '../ducks/project';
import images from '../ducks/images';
import navigation from '../ducks/navigation';
import user from '../ducks/user';
import layouts from '../ducks/layouts';
import addPhotos from '../ducks/addPhotos/addPhotos';
import selection from '../ducks/selection';
import modals from '../ducks/modals';
import settings from '../ducks/settings';
import wrap from '../ducks/wrap';
import snap from '../ducks/snap';
import preloader from '../ducks/preloader';
import loadedImages from '../ducks/loadedImages';
import messages from '../ducks/messages';
import pricing from '../ducks/pricing';
import error from '../ducks/error';
import marketingBanner from '../ducks/marketingBanner';

const zoomEditorReducers = combineReducers({
  routing,
  project: project.reducer,
  navigation: navigation.reducer,
  user: user.reducer,
  layouts: layouts.reducer,
  addPhotos: addPhotos.reducer,
  selection: selection.reducer,
  changesets: changesets.reducer,
  modals: modals.reducer,
  settings: settings.reducer,
  wrap: wrap.reducer,
  snap: snap.reducer,
  preloader: preloader.reducer,
  images: images.reducer,
  loadedImages: loadedImages.reducer,
  messages: messages.reducer,
  pricing: pricing.reducer,
  error: error.reducer,
  marketingBanner: marketingBanner.reducer,

  // fonts is set in preloadedState and does not change
  fonts: (state) => state || null,
});

export default zoomEditorReducers;
